/** Error message thrown when the view criteria is undefined. */
export const VIEW_CRITERIA_UNDEFINED = `View criteria must be defined.`;
/** Error message thrown when unexpected error happened in view retrieval */
export const VIEW_RETRIEVER_UNEXPECTED_ERROR = `An unexpected error has happened, please try again.`;
export const PERSONAL_POD = 'Personal';
/** The label of a Card inside Mfs */
export const MFS_CARD_TYPE = 'Card';
/** The label of a Tag inside Mfs */
export const MFS_TAG_TYPE = 'Tag';
/** The max level of recursive retrieval when iterating through card and nested cards for opinionated views */
export const VIEW_RETRIEVAL_MAX_DEPTH = 3;
/** The label of an internal use Tag Container node that holds reference of all available Tags in the Pod. */
export const MFS_TAG_CONTAINER_TYPE = 'Tag Container';
/** The single identifier used as the labelId for the Tag Container */
export const TAG_CONTAINER_ID = 'Tag Container Id';
export const MAX_TAG_UNTAG_BATCH_SIZE = 100;
/** List of reserved properties that cannot be set in a CardInput. */
export const ReservedCardProperties = [
    'label',
    'labelId',
    'displayText',
    'origin',
    'title',
    'secondaryLabels',
    'activities',
    'kind',
    'id',
    'tags',
    'updatedAt',
    'inUse',
];
/** The name suffix that will be used for creating and loading Pods created through MFS Folders SDK.*/
export const FOLDER_POD_NAME_SUFFIX = '02fd0275-74ff-4b12-8a94-719af744c614';
/** The production domain for calling MfsService */
export const MFS_SERVICE_PROD_DOMAIN = 'api.mfs.microsoft.com';
/** A subset of the cacheKey that's used to cache podId for a default pod */
export const DEFAULT_POD_CACHE_KEY_PREFIX = 'defaultPod';
/** Id of the pod before its connected to ODSP */
export const DETACHED_POD_ID = 'detachedPodId';
/** Event on mfsClient that indiciates that the pod is connected to ODSP  */
export const POD_CONNECTED_EVENT = 'fluidConnected';
//# sourceMappingURL=constants.js.map